module.exports = __webpack_public_path__ + "src/assets/games/10/586.jpg";